export default "__VITE_ASSET__C5Nl0VLh__"